export default {
    en: {
        titre: 'Review details',
        instructionsTitre: 'It’s time to review your offer',
        click2call: 'talk to our specialists',
        click2call_aria: 'This link will open in a new window.',
        instructionsDesc:
            'Review the information you entered before you continue.',
        back: 'Back',
        cancel: 'Save and leave',
        renouveller: 'Confirm',
        refuser: 'Change renewal details',
        modaleTitre: 'Change renewal details?',
        modaleMessage:
            "If you change the renewal details, you’ll cancel all your co-borrower's choices—the rate and the payment amount and frequency. The available rates may be different.",
        modaleMessageSI:
            'Your co-borrower will need to sign a new contract with the options you select.',
        modaleAcceptButton: 'Change renewal details',
        modaleStayButton: 'Keep current details'
    },
    fr: {
        titre: 'Validation',
        instructionsTitre: 'C’est le moment de réviser vos choix',
        click2call: 'parler à nos spécialistes',
        click2call_aria: 'Ce lien s’ouvrira dans une nouvelle fenêtre.',
        instructionsDesc:
            'Validez les informations entrées avant de continuer.',
        back: 'Précédent',
        cancel: 'Enregistrer et quitter',
        renouveller: 'Confirmer',
        refuser: 'Choisir une autre option',
        modaleTitre: 'Choisir une autre option?',
        modaleMessage:
            'Si vous choisissez une autre option, vous annulerez les choix de votre coemprunteur – taux, fréquence et montant des paiements. Les taux disponibles pourraient être différents.',
        modaleMessageSI:
            'Votre coemprunteur devra signer un nouveau contrat avec les options que vous choisissez.',
        modaleAcceptButton: 'Choisir une autre option',
        modaleStayButton: 'Conserver l’option actuelle'
    }
};
